
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sklep/panel/ustawienia",
      function () {
        return require("private-next-pages/sklep/panel/ustawienia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sklep/panel/ustawienia"])
      });
    }
  